import type React from 'react'
import type { IconProps } from './types'

const OrganizationChartIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M15 20V18H11V13H9V15H2V9H9V11H11V6H15V4H22V10H15V8H13V16H15V14H22V20H15ZM17 18H20V16H17V18ZM4 13H7V11H4V13ZM17 8H20V6H17V8Z' />
	</svg>
)

export default OrganizationChartIcon
